<template>
  <div class="backlog">
    <div class="backlog_top" v-if="backlogStep == 1">
      <div class="content_top flex Flexalign FlexBetween">
        <div class="top_left flex Flexalign">
          <el-image class="user_head" :src="userInfo.headImage"></el-image>
          <div class="flex flexcolumn flex-1 content_top_content ml-20">
            <div>欢迎回来：{{ userInfo.name }}同学，{{ dateInfo.period }}</div>
            <div class="toverflows toverflow2 mt-10 current_progress">
              在学：{{ progressInfo.chapterName }}
            </div>
          </div>
        </div>
        <div class="flex flexcolumn FlexEnd">
          <div class="current_progress">{{ dateInfo.date }} {{ dateInfo.weekDay }}</div>
          <div class="btn_start cursor_pointer mt-5" @click="getMenu(2)">开始学习</div>
        </div>
      </div>
      <div class="line-box flex Flexalign mt-20 ml-20">
        <div class="line_green"></div>
        <div class="difficult_text ml-8">待处理</div>
      </div>
      <div class="pending_box flex p-20 FlexBetween">
        <div class="pending_one cursor_pointer" v-for="(item, index) in pendingList" :key="index"
          :class="[item.type == 'homework' ? 'pending_one_homework' : '']" @click="goPendingInfo(item)">
          <div class="pt-15 pl-20">{{ item.title }}</div>
          <div class="flex Flexalign pending_info pl-20">
            <div class="mt-15">
              <el-badge :value="`${item.pendingFinishAdd ? '+' + item.pendingFinishAdd : ''}`">{{ item.pendingFinish
              }}</el-badge>
              <div class="finish_text mt-5">待完成</div>
            </div>
            <div class="mt-15 ml-40">
              <el-badge :value="`${item.completedAdd ? '+' + item.completedAdd : ''}`">{{
                item.completed
              }}</el-badge>
              <div class="finish_text mt-5">已完成</div>
            </div>
            <div class="mt-15 ml-40">
              <el-badge :value="`${item.totalAdd ? '+' + item.totalAdd : ''}`">{{
                item.total
              }}</el-badge>
              <div class="finish_text mt-5">总数</div>
            </div>
            <el-image class="test_exam_bg" :src="imgPath(item.type == 'exam' ? 'test_exam_bg.png' : 'homewor_exam_bg.png')
              "></el-image>
          </div>
        </div>
      </div>
      <div class="flex FlexBetween mt-30">
        <div class="calendar_list">
          <div class="line-box flex Flexalign mt-20 ml-20">
            <div class="line_green"></div>
            <div class="difficult_text ml-8">开放小节</div>
          </div>
          <div class="calendar flex Flexalign FlexBetween px-10 mt-15">
            <el-image class="arrow_left cursor_pointer" :src="iconPath('arrow_left.png')"
              @click="changeWeek(-1)"></el-image>
            <div class="day-column cursor_pointer" v-for="(day, index) in currentWeek" :key="index"
              :class="{ 'active-day': isToday(day.date) }" @click="changeToday(day)">
              <div class="section-list flex flexcolumn Flexalign Flexjustify">
                <div>{{ weekDays[index] }}</div>
                <div>{{ day.dateString }}</div>
              </div>
            </div>
            <el-image class="arrow_left cursor_pointer" :src="iconPath('arrow_right.png')"
              @click="changeWeek(1)"></el-image>
          </div>
          <div class="section_list ml-10 scroll_y hidden_scroll" v-if="sectionList.length">
            <div class="section_one mt-10" v-for="(item, index) in sectionList" :key="index">
              <div>{{ item.chapterName }}</div>
              <div class="mt-10 section_type">{{ item.courseInfo?.teachingMethod == 1 ? "录播课" : '直播课' }}</div>
            </div>
          </div>
          <div v-else>
            <moe-empty url="moe_empty_bg_img.png" emptyText="暂无新开放小节"></moe-empty>
          </div>
        </div>
        <div>
          <div class="top_banner_right flex flexcolumn"
            :class="[!companionTeacherInfo.businessUserPhone ? 'top_banner_right_new' : '']">
            <div class="flex FlexBetween">
              <div class="line-box flex Flexalign">
                <div class="line_green"></div>
                <div class="difficult_text ml-8">公告</div>
              </div>
              <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goNotice">
                查看更多
                <div class="flex Flexalign" style="margin-left: 5px">
                  <el-icon :size="18">
                    <ArrowRight color="rgba(102, 102, 102, 1)" />
                  </el-icon>
                </div>
              </div>
            </div>
            <div class="notice_list scroll_y hidden_scroll" v-if="noticeList.length">
              <div class="notice_one flex Flexalign FlexBetween cursor_pointer" v-for="(item, index) in noticeList"
                :key="index" @click="goNoticeDetail(item)">
                <div class="notice_time">{{ item.createTime?.split(" ")[0] }}</div>
                <div class="notice_title flex-1 toverflow">{{ item.noticeTitle }}</div>
              </div>
            </div>
            <div v-else>
              <moe-empty url="moe_empty_bg_img.png" emptyText="暂无公告"></moe-empty>
            </div>
          </div>
          <div class="top_banner_right flex flexcolumn my-15 companion_teacher_box"
            v-if="companionTeacherInfo.businessUserPhone">
            <div class="flex FlexBetween">
              <div class="line-box flex Flexalign">
                <div class="line_green"></div>
                <div class="difficult_text ml-8">伴学师</div>
              </div>
            </div>
            <div class="companion_teacher flex FlexBetween Flexalign mt-15">
              <div class="flex Flexalign">
                <el-image class="companionTeacherInfo_image" :src="companionTeacherInfo.image"></el-image>
                <div class="ml-15">
                  <div class="companionTeacherInfo_name">
                    {{ companionTeacherInfo.businessUserName }}
                  </div>
                  <div>{{ $Tools.phoneHide(companionTeacherInfo.businessUserPhone) }}</div>
                </div>
              </div>
              <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="companionTeacherService">
                伴学服务
                <div class="flex Flexalign" style="margin-left: 5px">
                  <el-icon :size="18">
                    <ArrowRight color="rgba(102, 102, 102, 1)" />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <afterHomework v-if="backlogStep == 2" @changeBacklogStep="changeBacklogStep" :courseId="courseDetail.courseId"></afterHomework>
    <examList v-if="backlogStep == 3" @changeBacklogStep="changeBacklogStep" :courseDetail="courseDetail"></examList>
    <companionTeacherQuestion ref="companionTeacherQuestion" @addQuestion="addQuestion"></companionTeacherQuestion>
    <addQuestion ref="addQuestion" :companionTeacherInfo="companionTeacherInfo" :courseDetail="courseDetail">
    </addQuestion>
  </div>
</template>

<script>
import { mapState } from "vuex";
import afterHomework from "./afterHomework.vue";
import companionTeacherQuestion from "@/components/popup/companionTeacherQuestion.vue";
import addQuestion from "@/components/popup/addQuestion.vue";
import examList from './examList.vue';
export default {
  name: "GjkcH5Backlog",
  props: {
    courseDetail: {},
    companionTeacherInfo: {},
    backlogStepPass: {}
  },
  components: { afterHomework, companionTeacherQuestion, addQuestion, examList },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    // 生成当前周的日期数组
    currentWeek() {
      const monday = this.getMonday(this.currentDate);
      const week = [];

      for (let i = 0; i < 7; i++) {
        const date = new Date(monday);
        date.setDate(monday.getDate() + i);

        const dateString = this.formatDate(date);

        week.push({
          date: date,
          dateString: dateString,
        });
      }

      return week;
    },
  },
  watch: {
    courseDetail: {
      handler() {
        this.getNoticeList();
        this.getAfterHomeworkCount();
        this.getMyCourseProgress();
        this.getExamCount();
      },
      deep: true,
      immediate:true
    },
  },
  data() {
    return {
      backlogStep: 1,
      dateInfo: {},
      pendingList: [
        {
          title: "考试测验",
          pendingFinish: 0,
          pendingFinishAdd: 0,
          completed: 0,
          completedAdd: 0,
          total: 0,
          totalAdd: 0,
          type: "exam",
        },
        {
          title: "课后作业",
          pendingFinish: 0,
          pendingFinishAdd: 0,
          completed: 0,
          completedAdd: 0,
          total: 0,
          totalAdd: 0,
          type: "homework",
        },
      ],
      currentDate: new Date(),
      weekDays: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      sectionList: [],
      noticeList: [],
      noticeListQuery: {
        courseId: "",
        page: 1,
        pageSize: 5,
      },
      todayDate: new Date(),
      progressInfo: {},  // 学习进度信息
    };
  },

  mounted() {
    this.getCurrentTimeInfo();
    this.getOpenChapterList();
    // 接受父组件传的值
    setTimeout(() => {
      if (!this.$Tools.empty(this.backlogStepPass)) {
        this.backlogStep = this.backlogStepPass;
      }
    }, 500)
  },

  methods: {
    // 获取当前学习进度
    getMyCourseProgress() {
      if (this.courseDetail.courseId) {
        this.$Api.course
          .getMyCourseProgress({ courseId: this.courseDetail.courseId })
          .then((res) => {
            this.progressInfo = res.data.data;
          })
          .catch(() => { });
      }
    },
    // 提问
    addQuestion() {
      this.$refs.addQuestion.addQuestionShow = true;
    },
    // 伴学师服务
    companionTeacherService() {
      this.$refs.companionTeacherQuestion.companionTeacherQuestionShow = true;
    },
    // 课后作业统计
    getAfterHomeworkCount() {
      if (this.courseDetail.courseId) {
        this.$Api.exam
          .getAfterHomeworkCount(this.courseDetail.courseId)
          .then((res) => {
            this.pendingList[1].completed = res.data.data.completed;
            this.pendingList[1].pendingFinish = res.data.data.unfinished;
            this.pendingList[1].total = res.data.data.total;
          })
          .catch(() => { });
      }
    },
    // 考试统计
    getExamCount() {
      this.$Api.exam.getExamCount().then(res => {
        this.pendingList[0].completed = res.data.data.completed;
        this.pendingList[0].pendingFinish = res.data.data.unfinished;
        this.pendingList[0].total = res.data.data.total;
      }).catch(() => { })
    },

    getMenu(menu) {
      this.$emit("getMenu", menu);
    },
    changeBacklogStep(value) {
      this.backlogStep = value;
    },
    goPendingInfo(info) {
      if (info.type == "homework") {
        this.backlogStep = 2;
      } else {
        this.backlogStep = 3;
        // this.$Dialog.toast('功能开发中', { type: 'warning' });
      }
    },
    getNoticeList() {
      this.noticeListQuery.courseId = this.courseDetail.courseId;
      this.$Api.course
        .getCourseNoticeList(this.noticeListQuery)
        .then((res) => {
          this.noticeList = res.data.data.list;
        })
        .catch(() => { });
    },

    goNotice() {
      this.href("/notice");
    },
    goNoticeDetail(info) {
      this.href("/noticeDetail", { noticeId: info.noticeId });
    },
    getCurrentTimeInfo() {
      const now = new Date(); // [1,6](@ref)

      // 获取年月日
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const date = String(now.getDate()).padStart(2, "0");

      // 获取星期
      const weekDays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekDay = weekDays[now.getDay()]; // [8,10](@ref)

      // 判断时段
      const hours = now.getHours();
      let period;
      if (hours < 12) period = "上午好";
      else if (hours === 12) period = "中午好";
      else if (hours < 18) period = "下午好";
      else period = "晚上好"; // [2,12,13](@ref)

      this.dateInfo = {
        date: `${year}年${month}月${date}日`,
        weekDay,
        period,
      };
    },
    // 获取当前周的周一
    getMonday(date) {
      const d = new Date(date);
      const day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1); // 调整周一为一周的第一天
      return new Date(d.setDate(diff));
    },
    // 格式化日期为 MM-DD
    formatDate(date) {
      // const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${month}.${day}`;
    },
    // 格式化日期显示（月/日）
    formatDayDate(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}日`;
    },
    // 判断是否为今天
    isToday(date) {
      const today = this.todayDate;
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      );
    },
    changeToday(info) {
      this.todayDate = info.date;
      this.getOpenChapterList();
    },
    // 获取某个时间课程开课的章节列表
    getOpenChapterList() {
      let listQuery = {
        startOpenRangeTime: '',
        endOpenRangeTime: '',
        page: 1,
        pageSize: 999
      }
      listQuery.startOpenRangeTime = this.$Moment(this.todayDate).format('YYYY-MM-DD 00:00:00');
      listQuery.endOpenRangeTime = this.$Moment(this.todayDate).format('YYYY-MM-DD 23:59:59');
      this.$Api.course.getOpenChapterList(listQuery).then(res => {
        this.sectionList = res.data.data.list;
      }).catch(() => { })
    },
    // 切换周
    changeWeek(step) {
      const newDate = new Date(this.currentDate);
      newDate.setDate(newDate.getDate() + step * 7);
      this.currentDate = newDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.backlog {
  .backlog_top {
    width: 762px;
    height: 321px;
    background: #ffffff;
    border-radius: 10px;

    .content_top {
      box-sizing: border-box;
      width: 762px;
      height: 109px;
      background: #fafafa;
      border-radius: 10px 10px 0px 0px;
      border-radius: 10px;
      color: #333333;
      padding: 20px 30px;
      box-sizing: border-box;

      .user_head {
        width: 65px;
        height: 65px;
        border-radius: 50%;
      }

      .content_top_content {
        width: calc(100% - 160px);
      }

      .current_progress {
        color: #606060;
        font-size: 14px;
      }

      .btn_start {
        width: 88px;
        height: 30px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 18px;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
        // padding: 0 15px;
      }
    }

    .line-box {
      font-size: 12px;
      color: #999999;

      .line_green {
        width: 3px;
        height: 16px;
        background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
        border-radius: 4px;
      }

      .difficult_text {
        font-size: 16px;
        color: #111111;
      }
    }

    .pending_box {
      .pending_one {
        width: 352px;
        height: 117px;
        background: linear-gradient(131deg, #deeafd 0%, #f2f5fc 100%);
        border-radius: 10px;
        position: relative;

        .pending_info {
          :deep(.el-badge__content.is-fixed) {
            right: calc(var(--el-badge-size) / 4);
          }

          .finish_text {
            font-size: 12px;
            color: #909090;
          }
        }

        .test_exam_bg {
          width: 110px;
          height: 96px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }

      .pending_one_homework {
        background: linear-gradient(131deg, #fef4ea 0%, #fff6ed 100%);
      }
    }

    .calendar_list {
      width: 443px;
      height: 405px;
      background: #ffffff;
      border-radius: 9px;

      .calendar {
        .arrow_left {
          width: 20px;
          height: 20px;
        }

        .day-column {
          width: 40px;
          height: 60px;
          font-size: 14px;
        }

        .active-day {
          background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
          border-radius: 20px;
          color: #ffffff;
        }

        .section-list {
          height: 100%;
        }
      }

      .section_list {
        max-height: 280px;

        .section_one {
          width: 422px;
          height: 70px;
          background: #fafafa;
          border-radius: 10px;
          font-size: 14px;
          color: #303030;
          padding: 10px 20px;
          box-sizing: border-box;

          .section_type {
            font-size: 12px;
            color: #909090;
          }
        }
      }
    }

    .top_banner_right {
      width: 300px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      padding: 12px;
      height: 280px;

      .notice_list {
        height: 260px;
        // overflow: hidden;
      }

      .notice_one {
        color: #333333;
        font-weight: 600;
        margin-top: 25px;

        .notice_title {
          margin-left: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .top_banner_right_new {
      height: 405px;
    }

    .companion_teacher_box {
      height: 115px;
      font-size: 14px;
      color: #909090;

      .companionTeacherInfo_image {
        width: 38px;
        height: 38px;
        border-radius: 50%;
      }

      .companionTeacherInfo_name {
        color: #111111;
      }
    }

    .recommend {
      font-weight: bold;
      font-size: 18px;
      color: #111111;
    }

    .more_btn {
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }

    .course_list {
      margin-top: 10px;
      width: 100%;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      padding: 12px;

      .course_one {
        background: #ffffff;
        border-radius: 10px;
        width: 100%;
        margin-top: 15px;

        .course_title {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .course_rank_list {
          .course_one_img {
            width: 100px;
            height: 70px;
            border-radius: 10px;
          }

          .course_info {
            height: 70px;
            margin-left: 11px;

            .course_rate {
              :deep(.el-rate .el-rate__icon) {
                margin-right: 0;
              }

              .course_price {
                color: #ff6619;
                font-size: 18px;
                font-weight: 600;

                .course_price_unit {
                  font-size: 16px;
                  font-weight: 400;
                }
              }
            }

            .course_online_info {
              .course_online {
                font-size: 14px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
}
</style>
